
import * as React from 'react'
import {CSSProperties} from 'react';
import {MajorAccountsHdr} from '../Components/MajorAccountsHdr';
import * as Tgcc from '../tgccGlobal';
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter';
import Radium, { StyleRoot } from 'radium';
import * as Request from '../tgccRequest';
import {Message} from '../Components/Message';
import {browserHistory} from 'react-router';



const feedbackDiv: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    margin:'10% auto',    
}

const btn : CSSProperties = {
    border: "1px solid transparent",
    backgroundColor: "rgb(226, 117, 88)",
    height: '40px',
    lineHeight: '40px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px auto',
    width: '142px',
    fontFamily: 'Reitam'
}
const label: CSSProperties = {
    fontFamily:"AveriaSerifRegular",
    flexGrow:1,
    textAlign:'left'
}
const hdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'AveriaSerifLightItalic',
    color: 'black',
    fontSize:'15px'
}

const style: CSSProperties = {
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"AveriaSerifRegular",
    width:'70%',
    backgroundColor:'#F6F3EE'

}
const errStyle: CSSProperties = {
    color:'red',
    textAlign:'center',
    fontSize:'15px'
}
const formDiv: React.CSSProperties = {
    backgroundColor:'white',
    width:'425px',
    padding:'20px',
    height:'365px',
    margin:'auto'
}


const inputDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    justifyContent: 'space-around',
    alignItems:'left',
    marginBottom:'10px'
}
const h1: React.CSSProperties = {
    fontFamily:"Reitam",
    textAlign:'center'
}

const p: React.CSSProperties = {
    textAlign:'center',
    fontSize:'18px',
    marginBottom:'30px',
    paddingLeft:'10px',
    paddingRight:'10px'
}
const points = Object.assign({},h1,{fontSize:'28px',marginBottom:'5px'});
const findout = Object.assign({},h1,{fontSize:'28px'});
const generate = Object.assign({},h1,{letterSpacing:'5px',fontSize:'30px',width:'85%',margin:'50px auto 30px'})

const imgStyle: React.CSSProperties = {
    backgroundImage: 'url('+ Tgcc.ResolveUrl('~/images/ContactUsMa.jpg')+')',
    backgroundPosition:'center',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    width:'100%',
    height:'500px',
}
const hr: React.CSSProperties = {
    width:'930px',
    backgroundColor:'black',
    margin:'40px auto 20px',
    height:'1px',

}
const smallHr: React.CSSProperties = {
    height:'1px',
    margin:'auto',
    backgroundColor:'black',
    width:'75%'
}
const help: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'Reitam',
    margin:'30px auto'
}
const contactInfo = Object.assign({},help,{})
const contactdiv: React.CSSProperties = {
    display:'flex',
    justifyContent: 'space-around',
    width:'930px',
    margin:'auto',
    textAlign:'center'
}
const contactInfoDiv: React.CSSProperties = {
    backgroundColor:'white',
    width:'425px',
    height:'275px'
}
const contactTxt: React.CSSProperties = {
    fontFamily:'AveriaSerifLightItalic'
}
const callDiv: React.CSSProperties = {
    marginTop:'9%'
}
class _MajorAccountsLanding extends React.Component<Tgcc.BaseProps,any> {
    state = {
        name:null,
        email:null,
        message:null,
        finished:false,
        error:'',
        isWaiting: false,
        help: false,
        contactName: null,
        phone:null
    }
    handleNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({name:evt.currentTarget.value});
    }
    handleContactNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({contactName:evt.currentTarget.value});
    }
    handleEmailChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({email:evt.currentTarget.value});
    }

    handlePhoneChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({phone:evt.currentTarget.value});
    }
    sendMessage = () => {       
        if(!this.state.name){
            this.setState({error:"Please provide your business name."})
        } else if(!this.state.email){
            this.setState({error:"Please provide your email address."})
        }else if(!this.state.contactName){
            this.setState({error:"Please provide your name."})
        }else if(!this.state.phone){
                this.setState({error:"Please provide your phone number"})
        }else {
            this.setState({isWaiting:true});
            var contactUs = new Tgcc.ContactUs;
            contactUs.name = this.state.name;
            contactUs.email = this.state.email;
            contactUs.contactName = this.state.contactName;
            contactUs.phone = this.state.phone;
            contactUs.timestamp = new Date().toLocaleString();
            Request.sendContactUS(contactUs,this.finished)
        }
    }
    finished = () => {
        this.setState({finished:true});
    }
    whenFinished = () => {
        browserHistory.push(Tgcc.Routes.Home);
    }
    getThankYou = () => {
        return <Message 
            Title="We will be in touch!"         
            UseTitleScript={true}
            Message1="Thanks for reaching out!"
            onContinue={this.whenFinished}
        />
    }
    helpMe = () => {
        if(this.state.help){
            this.setState({help:false});
        }else {
            this.setState({help:true});
        }
        
    }
    cancel = () => {
        this.setState({help:false});
        this.setState({finished:false});
        this.setState({isWaiting:false});
    }

    
    render () {
        var thankYou = this.state.finished ? this.getThankYou() : null;
        var waiting = this.state.isWaiting ? Tgcc.workingGif: <div style={btn} onClick={this.sendMessage}>Submit</div> 
        return (
            <div>
            <MajorAccountsHdr />
            <div style={imgStyle} className="restBanner"></div>
            <h1 style={generate}>GENERATE REVENUE FOR YOUR RESTAURANT OR BUSINESS WITH $0 COST OR INVESTMENT</h1>
            <h2 style={points}>WE DO THE WORK</h2>
            <p style={p}>Our team utilizes 25+ years of apparel and graphic design expertise to quickly develop a simple and unique apparel webstore just for you.</p>
            <h2 style={points}>YOU SPREAD THE WORD</h2>
            <p style={p}> Share your unique webstore link to your loyal followers via Facebook, Instagram, and Twitter.</p>
            <h2 style={points}>WE PRINT YOUR SHIRTS</h2>
            <p style={p}>We take care of gathering orders and payments, printing your apparel, and individually shipping to your fans.</p>
            <h2 style={points}>WE SEND YOU A CHECK</h2>
            <p style={p}>Most importantly, we send you a check within one week of your apparel shipping. <br/> Typical t-shirt profits range from $8-$12 per shirt.</p>
            <hr style={hr}></hr>
            <h2 style={help}>WE WANT TO HELP</h2>
            <div style={contactdiv} className="maContactDiv">
                <div style={contactInfoDiv} className="maInfoDiv">
                    <div style={callDiv}>
                        <h2 style={findout}>Contact Info</h2>
                        <div style={contactTxt}><i>Give me a call now. I'd love to help!</i></div>
                    </div>
                    <hr style={smallHr}></hr>
                    <div>
                        <h2 style={findout}>Andy Coyne</h2>
                        <div><a href="mailto:andy.coyne@grafcow.com" style={contactTxt}>andy.coyne@grafcow.com</a>
                        <div style={contactTxt}>864.380.3734</div>
                    </div>
                </div>
                </div>
            <div style={formDiv} className="contactForm">
              <div id="feedback"></div> 
                    <h1 style={findout}>OR WE CAN CONTACT YOU</h1>
                    <div style={hdr}>Leave your info and we’ll call you with more details.</div>
                    <div style={errStyle}>{this.state.error}</div>
                    <div style={feedbackDiv} className='feedbackDiv'>
                        <div style={inputDiv}>
                            <label htmlFor="Name" className ="maContactLabel" style={label}>Business Name:</label>
                            <input style={style} className="maContactInpt" type="text" name="name" onChange={this.handleNameChange}/>
                        </div>
                        <div style={inputDiv}>
                            <label htmlFor="Name" className ="maContactLabel" style={label}>Contact Name:</label>
                            <input style={style} type="text" className="maContactInpt" name="name" onChange={this.handleContactNameChange}/>
                        </div>
                        <div style={inputDiv}>
                            <label htmlFor="email" className ="maContactLabel" style={label}>Email:</label>
                            <input style={style} type="text" className="maContactInpt" name="email" onChange={this.handleEmailChange}/>
                        </div>
                        <div style={inputDiv}>
                            <label htmlFor="message" className ="maContactLabel" style={label}>Phone:</label>
                            <input style={style} type="text" className="maContactInpt" name="phone" onChange={this.handlePhoneChange}/> 
                        </div>
                        {waiting}
                    </div>
                      {thankYou}

            </div>
            </div>
            <MajorAccountsFooter state={this.props.state} />

            </div>
        )
    }
}

export var MajorAccountsLanding = Radium(_MajorAccountsLanding);